import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=2b7fde64&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=2b7fde64&prod&scoped=true&lang=css"
import style1 from "./OrderForm.vue?vue&type=style&index=1&id=2b7fde64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fde64",
  null
  
)

export default component.exports